import React, { createContext, useMemo } from 'react';
import { useLocalStorage } from '../services/useLocalStorage';

export const ContentContext = createContext();

export const ContentProvider = ({ children }) => {
	const [item, setItem] = useLocalStorage('item', 'Perfil');

	// establecer el item seleccionado
	const setItemContent = (id) => {
		setItem(id);
	};

	// remover el item seleccionardo
	const removeItemContent = () => {
		setItem('Perfil');
	};

	const value = useMemo(
		() => ({
			item,
			setItemContent,
			removeItemContent,
		}),
		[item]
	);

	return <ContentContext.Provider value={value}>{children}</ContentContext.Provider>;
};
